export const Routes = {
  PRESENTATION_BUILDER: '/client-deliverable/presentationbuilder/:surveyId',
  PRESENTATION_BUILDER_PDF: '/client-deliverable/pdf/presentationbuilder/:surveyId',
  PREVIEW: '/client-deliverable/preview/:surveyId',
  BROKER_VIEW: '/client-deliverable/broker/presentationbuilder/:surveyId',
  MOBILE_BASE: '/client-deliverable/presentationbuilder',
  MOBILE_COVER_PAGE: '/client-deliverable/presentationbuilder/:surveyId/coverpage',
};
